import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { SurveyElementModule } from './app/modules/survey-element.module';

platformBrowserDynamic()
  .bootstrapModule(SurveyElementModule)
  .catch(err => console.error(err));
